module.exports = __webpack_public_path__ + "img/arc.b52072b8.png";